module.exports = __webpack_public_path__ + "img/order-wx.3bd46ab3.png";